import { Component } from '@angular/core';

@Component({
  selector: 'app-address-number-request-portal',
  templateUrl: './address-number-request-portal.component.html',
  standalone: false,
})
export class AddressNumberRequestPortalComponent {}
